"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    prefix: 'buc', // stands for ba-ui-carbon
};
